import { validatePassword, PasswordValidationStatus } from 'firebase/auth';
import { auth } from '../config/firebase';

/**
 * Requisitos de la contraseña tal como los tiene Firebase en Authentication →
 * Settings → Password policy. Se leen de Firebase (validatePassword descarga la
 * política una vez y la guarda) en vez de copiarlos aquí, para que el
 * formulario no se quede desfasado si se cambia la política en la consola.
 */
export interface RequisitoContrasena {
  texto: string;
  cumple: boolean;
}

// Sin política activada (o sin red) Firebase solo exige 6 caracteres
const MINIMO_FIREBASE = 6;

function requisitosBasicos(password: string): RequisitoContrasena[] {
  return [{ texto: `Al menos ${MINIMO_FIREBASE} caracteres`, cumple: password.length >= MINIMO_FIREBASE }];
}

export async function comprobarContrasena(password: string): Promise<RequisitoContrasena[]> {
  let estado: PasswordValidationStatus;
  try {
    estado = await validatePassword(auth, password);
  } catch {
    return requisitosBasicos(password);
  }
  const reglas = estado.passwordPolicy.customStrengthOptions;
  const lista: RequisitoContrasena[] = [];
  const min = reglas.minPasswordLength ?? MINIMO_FIREBASE;
  lista.push({ texto: `Al menos ${min} caracteres`, cumple: estado.meetsMinPasswordLength ?? password.length >= min });
  if (reglas.maxPasswordLength) {
    lista.push({ texto: `Como mucho ${reglas.maxPasswordLength} caracteres`, cumple: !!estado.meetsMaxPasswordLength });
  }
  // Firebase solo cuenta como letras la a-z y la A-Z: la ñ y las tildes no valen
  if (reglas.containsUppercaseLetter) {
    lista.push({ texto: 'Una letra mayúscula (A-Z)', cumple: !!estado.containsUppercaseLetter });
  }
  if (reglas.containsLowercaseLetter) {
    lista.push({ texto: 'Una letra minúscula (a-z)', cumple: !!estado.containsLowercaseLetter });
  }
  if (reglas.containsNumericCharacter) {
    lista.push({ texto: 'Un número (0-9)', cumple: !!estado.containsNumericCharacter });
  }
  if (reglas.containsNonAlphanumericCharacter) {
    lista.push({ texto: 'Un símbolo (por ejemplo ! @ # $ % &)', cumple: !!estado.containsNonAlphanumericCharacter });
  }
  return lista;
}
